module.exports = __webpack_public_path__ + "static/huiles-b4a1ddb1b0cebcf1d1e9bc08411ddfa5.jpg";